import React, { useEffect, useState, useContext, useRef } from 'react';
import * as S from './styles';
import { Context } from '../../services/contexts/StateContext';
import api from '../../services/api';
import { buscarDadosPlaca } from '../../services/Api_PlacaFipe';
import MaskedInput from 'react-text-mask';
import { format } from 'date-fns';
// -----------------------
import { PesquisaPadrao } from '../../componentes/Pesquisas/PesquisaPadrao';
import { PesquisaPlaca } from '../Pesquisas/PesquisaPlaca';
import { useAvisoEventos } from './ModalAvisoEventos';
import { Add_Arquivos } from '../../componentes/Cadastro/Add_Arquivos';
import { ModalCotacao_PREVIEW } from '../../componentes/Modal/ModalCota_PREVIEW';

import { ListaItemBD } from '../ListarPesquisas/listaItemBD';
import { Api_Veiculos } from '../../services/FiltrosApi/veiculos_api';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';
import { Functions, FunctModal, SetFunctions } from '../../componentes/Functions';
import icon_file from '../../midia/icon_pdf.svg';
import { descricaoParaTexto } from '../../services/descricaoEventoUtil';
// ----------------------------------------
function ModalEvento(props) {
    const { state, dispatch } = useContext(Context);
    const { evento, guincho, terceiro } = state.evento;
    const { veiculo } = state.veiculo;
    const { cliente } = state.cliente;
    const { parametroInit, playmodal, listaPesquisa } = state.parametros;
    const { editModal, atualizarModal, disabledEven } = parametroInit;
    const editandoVistoriaEvento = parametroInit.editandoVistoriaEvento === true;
    const { playModalDetalhesEven } = playmodal;

    const { PesqVeiculoPlaca, AddPlaca } = Api_Veiculos();
    const { AddEvento, AddFornecedor, PesqFornecedor, AtualizarIdEvento, PesquisarEventosPorPlaca } = ApiEvento();
    const { verificarPlaca: verificarPlacaEventos, modalAviso: modalAvisoEventos } = useAvisoEventos();

    const { EditarSelect, Play_Modal_Add } = Functions();
    const { FecharModal } = FunctModal();
    const { SetEvento, SetVeiculo, SetListaPesquisa } = SetFunctions();
    // Evento de colisão em aberto com fornecedor "Pre-Evento" que será complementado
    const [eventoComplemento, setEventoComplemento] = useState(null);
    const [novaDescricao, setNovaDescricao] = useState("");
    const editandoCampos = editModal && !disabledEven;
    const corTitulo = eventoComplemento && !editandoCampos ? "yellow" : "#00D594";
    const { SelectFile, AddArquivos } = Add_Arquivos({ permitirExcluirArquivosSalvos: !eventoComplemento });
    // -------------------------------

    const [ buscandoDadosPlaca, setBuscandoDadosPlaca] = useState(false);
    const [sucessoBuscaPlaca, setSucessoBuscaPlaca] = useState(false);
    const [dadosDivergentes, setDadosDivergentes] = useState(false);
    const [dadosCompletos, setdadosCompletos] = useState(false);
    const [erroNumero, setErroNumero] = useState(false);
    const [situacaoDivergente, setSituacaoDivergente] = useState(false);
    const [erroBuscaPlaca, setErroBuscaPlaca] = useState("");
    const [valorFipeNumerico, setValorFipeNumerico] = useState(false);
    const [maioresScoresFipe, setmaioresScoresFipe] = useState(false);
    const [valorMensalCotac, setValorMensalCotac] = useState(false);
    const [dadosFipeRecebidos, setDadosFipeRecebidos] = useState(false);

    const [ConfirmadoPlaca, setConfirmarDados] = useState(false);
    const [tipoEventoBusca, setTipoEventoBusca] = useState('');
    const [tipoEventoBuscaOpen, setTipoEventoBuscaOpen] = useState(false);
    const [referenciaRef, setReferenciaRef] = useState("");
    const [editarFornecedor, seteditarFornecedor] = useState(false);
    // ----------------------

    const ClickForn_Ref = useRef(null);
    const PlacaVeiculoRef = useRef(null);
    const EventoPlacaRef = useRef(null);

    const dataAtual = new Date();
    const dataFormatada = format(dataAtual, 'yyyy-MM-dd');

    // ----------------------------------------
    const SetGuincho = (key, value) => {
        dispatch({
            type: 'set_Guincho',
            payload: { ...guincho, [key]: value }
        });
    };
    // -------------------
    function ValidarEdicaoVistoriaEvento() {
        if (!editandoVistoriaEvento) {
            return true;
        }

        if (!evento.tipoEvento) {
            alert('Selecione o novo tipo de evento antes de continuar.');
            return false;
        }

        const tiposSemFornecedor = ['Roubo', 'Colisao_PT', 'Colisao_Incendio'];
        if (
            editandoVistoriaEvento &&
            evento.tipoEvento !== 'Financiamento' &&
            !tiposSemFornecedor.includes(evento.tipoEvento) &&
            !evento.id_Fornecedor
        ) {
            alert('Selecione um fornecedor antes de continuar.');
            return false;
        }

        return true;
    }

    //-------Atualizar-----------------------------
    function Atualizar() {
        if (disabledEven) {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, disabledEven: false }
            });
            return;
        }

        if (!ValidarEdicaoVistoriaEvento()) {
            return;
        }

        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                atualizarModal: true,
                editModal: false,
                disabledEven: false,
            }
        });
        dispatch({
            type: 'SET_PLAYMODAL',
            payload: {
                ...playmodal,
                playModalDetalhesEven: false,

            }
        });
    };

    // ----------------------------
    const [novoFornecedor, setnovoFornecedor] = useState(false);

    useEffect(() => {
        if (listaPesquisa.nomeItem?.length > 0) setnovoFornecedor(false);

        if (listaPesquisa.nomeItem?.length === 7 && !veiculo.id_Veiculo && playmodal.playModalEven) {
            //-Pesquisar ao digitar Placa-
            PesqVeiculoPlaca(listaPesquisa.nomeItem);
        } else {
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    alertaNovo: false,
                    listaVeiculo: [],
                    listaFornecedor: [],
                }
            });
        };
    }, [listaPesquisa.nomeItem]);

    // ----Abrir Novo Fornecedor----------
    function NovoFornecedor() {
        setnovoFornecedor(true);

        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                nomeItem: "",
                selectItem: '',
                alertaNovo: false
            }
        });

        dispatch({
            type: 'set_Evento',
            payload: {
                ...evento,
                id_Fornecedor: "",
                fornecedor: "",
                cnpjForne:"",
                chavePix: '',
            }
        });
    };

    // -----------------------------------

    const ehPreEvento = (nome) => String(nome || "")
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .trim().toLowerCase() === "pre-evento";

    const fornecedorPreEvento = ehPreEvento(evento.fornecedor);

    // ----------------------
    document.addEventListener("click", EventoDeClick, true);

    function EventoDeClick(e) {     
        if (!ClickForn_Ref.current?.contains(e.target)) {
            setReferenciaRef("RefFornecedor");
            seteditarFornecedor(false);
        };

        if (PlacaVeiculoRef.current?.contains(e.target)) {
            setReferenciaRef("veiculoPlaca");
        };

        if (EventoPlacaRef.current?.contains(e.target)) {
            setReferenciaRef("EventoPlaca");
        };
    };

    // -------------
    const [IndenizaçãoTotal, setIndenizaçãoTotal] = useState(false);
    const tipoEventoOptions = [
        { value: 'Guincho_Mecanica', label: 'Guincho P.Mecanica' },
        { value: 'Guincho_Eletrica', label: 'Guincho P.Eletrica' },
        { value: 'Borracheiro', label: 'Borracheiro' },
        { value: 'Recarga', label: 'Recarga Bateria' },

        { value: 'Guincho_Colisao', label: 'Guincho Colisao' },
        { value: 'C.Reserva', label: 'Carro Reserva' },
        { value: 'Retorno', label: 'Retorno Domicilio' },
        { value: 'Hospedagem', label: 'Hospedagem' },
        { value: 'Financiamento', label: 'Financiamento' },
        { value: 'Terceiro', label: 'Terceiro' },

        { value: 'Chaveiro', label: 'Chaveiro' },
        { value: 'Vidro_part', label: 'Quebra Vidro' },
        { value: 'Lanterna_part', label: 'Quebra Lanterna' },
        { value: 'Retrovisor_part', label: 'Quebra Retrovisor' },
        { value: 'Reparos_part', label: 'Pequeno Reparo' },

        { value: 'Roubo', label: 'Roubo Veiculo' },
        { value: 'Colisao_part', label: 'Colisão' },
        { value: 'Colisao_PT', label: 'Perca Total' },
        { value: 'Colisao_Incendio', label: 'Incendio' },
        
    ];
    const tiposComRef = ['Guincho_Colisao', 'C.Reserva', 'Retorno', 'Hospedagem', 'Financiamento', "Terceiro"];
    const tiposEventoRef = ['Roubo', 'Colisao_part', 'Colisao_PT', 'Colisao_Incendio'];
    const [eventosPlaca, setEventosPlaca] = useState([]);
    const [buscaEventosConcluida, setBuscaEventosConcluida] = useState(false);

    // ------------------------------
    useEffect(() => {
        let ativo = true;
        setBuscaEventosConcluida(false);
        if (!veiculo.id_Veiculo || !veiculo.placa || editModal || atualizarModal || playmodal.playModalEditar) {
            setEventosPlaca([]);
            setEventoComplemento(null);
            setBuscaEventosConcluida(true);
            return;
        }
        PesquisarEventosPorPlaca(veiculo.placa, { tiposEvento: tiposEventoRef, statusExcluir: ['C', 'E'] })
        .then(lista => {
            if (!ativo) return;
            setEventosPlaca(lista);

            const preEvento = lista.find(e => /^Colisao/.test(e.tipoEvento) && ehPreEvento(e.id_Fornecedor?.nome));
            if (!preEvento) {
                setEventoComplemento(null);
                return;
            }
            setEventoComplemento(preEvento);
            setNovaDescricao("");
            setReferenciaRef("RefFornecedor");
            dispatch({
                type: 'set_Evento',
                payload: {
                    ...evento,
                    id_Evento: preEvento._id,
                    id_Fornecedor: "",
                    fornecedor: "",
                    cnpjForne: "",
                    chavePix: "",
                    id_EventoRef: "",
                    tipo: preEvento.tipo,
                    tipoEvento: preEvento.tipoEvento,
                    codEvento: preEvento.codEvento,
                    dataEvento: preEvento.dataEvento ? String(preEvento.dataEvento).slice(0, 10) : '',
                    ocorrenciaBO: preEvento.ocorrenciaBO || "",
                    descricao: descricaoParaTexto(preEvento.descricao),
                    descricaoOriginal: preEvento.descricao,
                    status: preEvento.status,
                    placa: preEvento.placa,
                    orcamento: preEvento.orcamento || 0,
                    arquivos: [...(preEvento.arquivos || [])].reverse(),
                }
            });
            dispatch({
                type: 'set_Guincho',
                payload: {
                    ...guincho,
                    origem: preEvento.guincho?.origem || "",
                    destino: preEvento.guincho?.destino || "",
                    km: preEvento.guincho?.km || "",
                }
            });
            if (preEvento.terceiro) {
                dispatch({
                    type: 'set_Terceiro',
                    payload: { ...terceiro, ...preEvento.terceiro }
                });
            }
        })
        .catch(() => { if (ativo) { setEventosPlaca([]); setEventoComplemento(null); } })
        .finally(() => ativo && setBuscaEventosConcluida(true));

        return () => { ativo = false; };

    }, [veiculo.id_Veiculo, veiculo.placa]);

    // ----------------------------

    const SelecionarEventoRef = (id) => {
        const novoId = evento.id_EventoRef === id ? "" : id;
        const tipoValido = novoId ? tiposComRef.includes(evento.tipoEvento) : !tiposComRef.includes(evento.tipoEvento);
        const eventoRef = eventosPlaca.find(e => e._id === novoId);
        const dataRef = eventoRef?.dataEvento ? String(eventoRef.dataEvento).slice(0, 10) : "";
        dispatch({
            type: 'set_Evento',
            payload: { ...evento, id_EventoRef: novoId, dataEvento: dataRef, tipoEvento: tipoValido ? evento.tipoEvento : "" }
        });
    };

    const eventoSelecionadoRef = eventosPlaca.find(e => e._id === evento.id_EventoRef);
    const dataMinimaEvento = eventoSelecionadoRef?.dataEvento ? String(eventoSelecionadoRef.dataEvento).slice(0, 10) : "";
    const dataMinimaEventoFormatada = dataMinimaEvento ? format(new Date(dataMinimaEvento + 'T00:00:00'), 'dd/MM/yyyy') : "";

    const ValidarDataEventoMinima = (dataInformada) => {
        if (dataMinimaEvento && dataInformada && dataInformada < dataMinimaEvento) {
            alert(`A Data do Evento não pode ser anterior à data do evento selecionado (${dataMinimaEventoFormatada}).`);
            SetEvento('dataEvento', dataMinimaEvento);
            return false;
        }
        return true;
    };

    const tipoEventoDisponiveis = tipoEventoOptions.filter(option =>
        evento.id_EventoRef ? tiposComRef.includes(option.value) : !tiposComRef.includes(option.value)
    );
    const isFinanciamento = evento.tipoEvento === 'Financiamento';

    const SetFinanciamento = (key, value) => {
        const dados = { ...evento, [key]: value };
        const total = Number(dados.numeroParcelas) * Number(String(dados.valorParcela).replace(",", "."));
        dados.orcamento = Number.isFinite(total) && total > 0 ? total.toFixed(2) : 0;
        dispatch({ type: 'set_Evento', payload: dados });
    };
    // ---------------------------

    const getTipoEventoLabel = (value) => {
        const option = tipoEventoOptions.find(item => item.value === value);
        return option ? option.label : value || '';
    };
    // ----------------------------

    useEffect(() => {
        setTipoEventoBusca(getTipoEventoLabel(evento.tipoEvento));
    }, [evento.tipoEvento]);

    // ----------------------------

    const tipoEventoFiltrado = tipoEventoBusca ? tipoEventoDisponiveis.filter(option => option.label.toLowerCase().includes(tipoEventoBusca.toLowerCase())) : tipoEventoDisponiveis;

    // ----------------------------
    const TipoEventoInput = () => (
        <div className='listaFlexCol' style={{ width: "98%" }}>
            <span>Tipo Evento:</span>
            <input
                disabled={disabledEven}
                type='text'
                value={tipoEventoBusca}
                placeholder='Buscar tipo de evento'
                autoComplete='off'
                onFocus={() => setTipoEventoBuscaOpen(true)}
                onChange={(e) => {
                    setTipoEventoBusca(e.target.value);
                    setTipoEventoBuscaOpen(true);
                }}
                onBlur={() => setTimeout(() => setTipoEventoBuscaOpen(false), 150)}
                required
            />

            {tipoEventoBuscaOpen && tipoEventoFiltrado.length > 0 && (
                <div style={{ width: '100%', marginTop: '6px', background: '#1f1f1f', border: '1px solid #3881ff', borderRadius: '6px', maxHeight: '200px', overflowY: 'auto', display: 'flex', flexDirection: 'column', zIndex: 2 }}>
                    {tipoEventoFiltrado.map((option) => (
                        <button
                            key={option.value}
                            type='button'
                            style={{ textAlign: 'left', padding: '8px 10px', background: '#1f1f1f', color: '#fff', border: 'none', borderBottom: '1px solid #2d2d2d', cursor: 'pointer' }}
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={() => {
                                setTipoEventoBusca(option.label);
                                setTipoEventoBuscaOpen(false);
                                SetEvento('tipoEvento', option.value);
                                SetListaPesquisa('nomeItem', '');
                            }}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );

    // ----------Placa do Terceiro----------
    const [placaTerceiroBusca, setPlacaTerceiroBusca] = useState('');
    const [buscandoPlacaTerceiro, setBuscandoPlacaTerceiro] = useState(false);
    const [erroPlacaTerceiro, setErroPlacaTerceiro] = useState('');
    const exigePlacaTerceiro = evento.tipoEvento === 'Terceiro' && !!evento.id_EventoRef;

    // Data do evento Terceiro é sempre a do evento de referência
    useEffect(() => {
        if (exigePlacaTerceiro && dataMinimaEvento && evento.dataEvento !== dataMinimaEvento) {
            SetEvento('dataEvento', dataMinimaEvento);
        }
    }, [exigePlacaTerceiro, dataMinimaEvento, evento.dataEvento]);
    // ----------------------------

    const SelecionarTerceiro = (dados) => {
        dispatch({
            type: 'set_Terceiro',
            payload: { ...terceiro, ...dados }
        });
    };
    // -------------------------
    const LimparTerceiro = () => {
        setPlacaTerceiroBusca('');
        setErroPlacaTerceiro('');
        dispatch({
            type: 'set_Terceiro',
            payload: { ...terceiro, tipo: '', placa: '', chassi: '', anoMod: '', montadora: '', modelo: '', cor: '', valorFipe: '' }
        });
    };
    // -------------------------
    async function PesquisarPlacaTerceiro(placa) {
        setBuscandoPlacaTerceiro(true);
        setErroPlacaTerceiro('');
        try {
            const res = await api.get(`veiculo/filtrar/placa/${placa}`);
            if (res.data) {
                const v = res.data;
                SelecionarTerceiro({
                    tipo: v.tipo || '', placa: v.placa || placa, chassi: v.chassi || '', anoMod: v.anoMod || '',
                    montadora: v.marca || '', modelo: v.modelo || '', cor: v.cor || '', valorFipe: v.valorFipe || ''
                });
                return;
            }

            const fipe = await buscarDadosPlaca(placa);
            if (!fipe.marca) {
                setErroPlacaTerceiro('Veiculo não localizado.');
                return;
            }
            const valorFipe = String(fipe.valorFipe || '').replace(/[^0-9,.-]+/g, '').replace(/\./g, '').replace(',', '.').trim();
            const dadosTerceiro = {
                tipo: fipe.tipoVeiculo || '', placa: fipe.placa || placa, chassi: fipe.chassi || '', anoMod: fipe.anoModelo || '',
                montadora: (fipe.marca || '').toLowerCase(), modelo: fipe.modelo || '', cor: fipe.cor || '', valorFipe
            };

            // Persistir o veículo do terceiro no banco
            await api.post('/veiculo', {
                userCadastro: state.cliente.logado?.idLogado || null,
                id_Franquia: state.franquia.franquia?.id || null,
                id_Cliente: null,
                placa: dadosTerceiro.placa,
                modelo: dadosTerceiro.modelo,
                tipo: dadosTerceiro.tipo,
                marca: dadosTerceiro.montadora,
                valorFipe: dadosTerceiro.valorFipe,
                anoMod: dadosTerceiro.anoMod,
                cor: dadosTerceiro.cor,
                chassi: dadosTerceiro.chassi,
                situacao: fipe.situacao || '',
            });
            alert('Placa Adicionada!');
            SelecionarTerceiro(dadosTerceiro);
        } catch (error) {
            setErroPlacaTerceiro('Não foi possível buscar a placa do terceiro.');
        } finally {
            setBuscandoPlacaTerceiro(false);
        }
    };

    // -------------------------
    useEffect(() => {
        if (exigePlacaTerceiro && !terceiro.placa && placaTerceiroBusca.length === 7) {
            PesquisarPlacaTerceiro(placaTerceiroBusca.toUpperCase());
        }
    }, [placaTerceiroBusca, exigePlacaTerceiro]);

    // -------------
    function FuncEditarFornecedor() {
        seteditarFornecedor(true);
        dispatch({
            type: 'set_Evento',
            payload: {
                ...evento,
                id_Fornecedor: "",
                fornecedor: "",
                chavePix: ""
            }
        });
        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                nomeItem: "",
                SelectForn: "",
                id_nomeForn: "",
                listaFornecedor: [],
            }
        });
    }
    // -----------------------------

    useEffect(() => {
        if (evento.tipoEvento.length > 0 && evento.tipoEvento === "Roubo" || evento.tipoEvento === "Colisao_PT" || evento.tipoEvento === "Colisao_Incendio") {
            setIndenizaçãoTotal(true);
        }
        else if (evento.tipoEvento.length > 0) {
            setIndenizaçãoTotal(false);
        }
    }, [evento.tipoEvento]);
    
    // --------------------------------

    useEffect(() => {
        async function Add_Placa() { 
            if (ConfirmadoPlaca) {
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: {
                        ...listaPesquisa,
                        nomeItem: "",
                        selectItem: '',
                    }
                });
                
            
                if (listaPesquisa.listaVeiculo.length === 0 && dadosFipeRecebidos && veiculo.tipo) {
                    const resposta = await AddPlaca();
                    if (resposta._id) {
                        dispatch({
                            type: 'SET_PLAYMODAL',
                            payload: {
                                ...playmodal,
                                playModalEven: false,
                                playModalEvenPlaca: true
                            }
                        });
                    } else {
                        alert("Ocorreu um erro ao adicionar a placa. Tente novamente.");
                    }

                } else{
                    dispatch({
                        type: 'SET_PLAYMODAL',
                        payload: {
                            ...playmodal,
                            playModalEven: false,
                            playModalEvenPlaca: true
                        }
                    });
                }
            }
        }
        Add_Placa();
    }, [dadosFipeRecebidos, veiculo.tipo, ConfirmadoPlaca]);
    // -------------------------

    useEffect(() => {
      if (evento.id_Fornecedor) {
        seteditarFornecedor(false);
      }
    }, [evento.id_Fornecedor]);

    //###################################################################################
    return (
        <S.body
            detalhesLista={parametroInit.detalhesLista}
            editModal={editModal}
        >
            <S.Container>
                <S.div3>
                    <div className='titulo'>
                        <div className={'tituloUser'}>
                            <span>{playModalDetalhesEven ? 'Detalhes Evento' : editModal || atualizarModal ? 'EDITAR Evento' : 'Novo Evento'}</span>
                        </div>

                        <div
                            className='fechar'
                            onClick={() => FecharModal()}>X
                        </div>
                    </div>
                </S.div3>
                <div style={{borderTop: "1px solid #3881ff"}}/>

                {/* ---------PESQUISA PLACA---------- */}
                {modalAvisoEventos}
                <S.div3>
                    {
                    ((!veiculo.id_Veiculo || !cliente.id_Cliente ) && (!editModal || !atualizarModal)) ?
                    <div ref={PlacaVeiculoRef} style={{display: "flex", width:"100%", justifyContent:"center", flexDirection:"column"}} >
                        <S.divPesq>
                            <S.containerPesq>
                                <PesquisaPlaca
                                titulo = "PLACA:"
                                setBuscandoDadosPlaca={setBuscandoDadosPlaca}
                                setSucessoBuscaPlaca={setSucessoBuscaPlaca}
                                setDadosDivergentes={setDadosDivergentes}
                                dadosCompletos={dadosCompletos}
                                buscandoDadosPlaca={buscandoDadosPlaca}
                                setdadosCompletos={setdadosCompletos}
                                setErroNumero={setErroNumero}
                                setSituacaoDivergente={setSituacaoDivergente}
                                setErroBuscaPlaca={setErroBuscaPlaca}
                                setValorFipeNumerico={setValorFipeNumerico}
                                maioresScoresFipe={maioresScoresFipe}
                                setmaioresScoresFipe={setmaioresScoresFipe}  
                                valorMensalCotac={valorMensalCotac}
                                valorFipeNumerico={valorFipeNumerico}
                                dadosFipeRecebidos={dadosFipeRecebidos}
                                setDadosFipeRecebidos={setDadosFipeRecebidos}
                                verificarPlacaEventos={verificarPlacaEventos}
                                />
                            </S.containerPesq>
                        </S.divPesq>

                        {//---------MOSTRAR DADOS----------------------- 
                        (veiculo.placa || dadosFipeRecebidos) &&
                        <S.Modal>
                            <ModalCotacao_PREVIEW 
                            fazerCotacao={false}
                            dadosCompletos={dadosCompletos} 
                            setdadosCompletos={setdadosCompletos}
                            erroBuscaPlaca={erroBuscaPlaca}
                            sucessoBuscaPlaca={sucessoBuscaPlaca}
                            dadosDivergentes={dadosDivergentes}
                            situacaoDivergente={situacaoDivergente}
                            maioresScoresFipe={maioresScoresFipe}
                            setValorFipeNumerico={setValorFipeNumerico}
                            buscandoDadosPlaca={buscandoDadosPlaca}
                            valorMensalCotac={valorMensalCotac}
                            setvalorMensal={false}
                            />
    
                            { /*---------Buttons CONFIRMAR----------- */
                            (veiculo.modelo && veiculo.tipo) && 
                            <div style={{display:"flex", justifyContent:"center", marginTop:"10px", gap:"10px"}}>
                                <button
                                style={{ display:"flex",alignItems:"center", cursor: "pointer", backgroundColor: "red", color: "black",  padding: '12px', fontWeight: "bold"}}
                                type='button'
                                onClick={() => {
                                    veiculo.modelo ? SetVeiculo("modelo", "") : veiculo.tipo ? SetVeiculo("tipo", "") : setDadosFipeRecebidos(false);
                                    
                                    }}>
                                X
                                </button>
                                
                                <button
                                style={{ display:"flex",alignItems:"center", cursor: "pointer", backgroundColor: "#00FF00", color: "black",  padding: '12px', fontWeight: "bold"}}
                                type='button'
                                onClick={() => {
                                    setConfirmarDados(true);
                                    }}>
                                CONFIRMAR
                                </button>
                            </div>
                            }
                        </S.Modal>
                        }
                    </div>

                    :

                    (editModal || atualizarModal) ?
                    <S.box1>
                        <div className='listaFlexCol'>
                            <span style={{color:"#00D594"}}>PLACA:</span>
                            <div className='intem'>
                                {veiculo.placa}
                            </div>
                        </div>
                    </S.box1>
                    :
                    <div className='listaFlexCol' style={{ width: "98%" }}>
                        <span ref={PlacaVeiculoRef}> PLACA: </span>
                        <div
                            className='tituloHover'
                            style={{ cursor: !disabledEven ? "pointer" : "not-allowed" }}
                            onClick={() => !disabledEven ? EditarSelect("eventoPlaca") : ""}
                        >
                            {veiculo.placa}
                        </div>
                    </div>
                   }

                    {veiculo.id_Veiculo && cliente.id_Cliente &&
                    <div style={{ display: "flex", width: "98%", justifyContent: "space-between", marginTop: "5px" }} >
                        <div className='listaFlexCol'>
                            <span style={{color: corTitulo}}>Modelo:</span>
                            <div className='intem'>
                                {veiculo.modelo}
                            </div>
                        </div>
                        <div className='listaFlexCol'>
                            <span style={{color: corTitulo}}>Cliente:</span>
                            <div className='intem'>
                                {veiculo.nomeCliente ? veiculo.nomeCliente : cliente.nome}
                            </div>
                        </div>
                    </div>
                    }

                    {veiculo.id_Veiculo && cliente.id_Cliente && !playmodal.playModalEditar && !eventoComplemento && eventosPlaca.length > 0 &&
                    <div className='listaFlexCol' style={{ width: "98%", marginTop: "8px", flex: "none", overflow: "visible", flexShrink: 0 }}>
                        <span style={{color:"#00D594"}}>Selecione Evento:</span>
                        <div style={{ display: "flex", flexDirection: "column", flexShrink: 0 }}>
                            {eventosPlaca.map(ev => {
                                const selecionado = evento.id_EventoRef === ev._id;
                                const tipoLabel = tipoEventoOptions.find(o => o.value === ev.tipoEvento)?.label || ev.tipoEvento || '-';
                                return (
                                    <button
                                        key={ev._id}
                                        type='button'
                                        disabled={disabledEven}
                                        onClick={() => SelecionarEventoRef(ev._id)}
                                        style={{ textAlign: 'left', flexShrink: 0, minHeight: '34px', padding: '8px 10px', background: selecionado ? '#3881ff' : '#1f1f1f', color: '#fff', border: 'none', borderBottom: '1px solid #2d2d2d', cursor: 'pointer' }}
                                    >
                                        {ev.dataEvento ? format(new Date(ev.dataEvento), 'dd/MM/yyyy') : '-'} | {tipoLabel}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                    }
                </S.div3>

                {/* ---------Tipo Evento ------------- */}

                {playmodal.playModalEditar && editandoVistoriaEvento &&
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: "500px", backgroundColor: "#262626" }}>
                        {TipoEventoInput()}
                    </div>
                }

                {!playmodal.playModalEditar && veiculo.id_Veiculo && cliente.id_Cliente &&
                    (evento.id_EventoRef || (buscaEventosConcluida && eventosPlaca.length === 0)) &&
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: "500px", backgroundColor: "#262626" }}>
                        {TipoEventoInput()}
                    </div>
                }

                {/* ---------PLACA TERCEIRO------------- */}
                {exigePlacaTerceiro &&
                    <S.div3>
                        {terceiro.placa ?
                        <div style={{ display: "flex", width: "98%", justifyContent: "space-between", alignItems: "flex-end" }}>
                            <div className='listaFlexCol'>
                                <span style={{color:"#00D594"}}>Placa Terceiro:</span>
                                <div className='intem' style={{ textTransform: "uppercase" }}>{terceiro.placa}</div>
                            </div>
                            <div className='listaFlexCol'>
                                <span style={{color:"#00D594"}}>Modelo:</span>
                                <div className='intem'>{terceiro.modelo}</div>
                            </div>
                            {!disabledEven &&
                            <button type='button' onClick={LimparTerceiro}>X</button>
                            }
                        </div>
                        :
                        <div className='listaFlexCol' style={{ width: "98%" }}>
                            <span>Placa Terceiro:</span>
                            <MaskedInput
                            autoFocus
                            disabled={disabledEven || buscandoPlacaTerceiro}
                            value={placaTerceiroBusca}
                            className='uppercase'
                            type='text'
                            placeholder='placa do terceiro'
                            mask={[/\D/, /\D/, /\D/, /\d/, /\w/, /\d/, /\d/]}
                            onChange={e => setPlacaTerceiroBusca(e.target.value)}
                            guide={false}
                            />
                            {buscandoPlacaTerceiro && <span>Buscando...</span>}
                            {erroPlacaTerceiro && <span style={{ color: "red" }}>{erroPlacaTerceiro}</span>}
                        </div>
                        }
                    </S.div3>
                }
                
                {/* ---------FORNECEDOR---------- */}
                {
                (evento.tipoEvento && !IndenizaçãoTotal && !isFinanciamento) &&
                    <S.div3>
                        {!evento.id_Fornecedor || editarFornecedor ?
                        <div ref={ClickForn_Ref} style={{width:"100%", position:"relative"}} >
                            <div style={{ display: "flex", width:"100%", justifyContent:"center"}}>
                                <S.divPesq>
                                    <PesquisaPadrao
                                    refNomeCPF={true}
                                    mostrarPreEvento={evento.tipoEvento === "Colisao_part"}
                                    playTudo={false}
                                    titulo="Buscar Fornecedor"
                                    placeholder="nome ou cnpj"
                                    playModal_Add={Play_Modal_Add}
                                    Pesquisar={PesqFornecedor}
                                    PesqDentroModal={false}
                                    playBotao={false}
                                    Lupa={true}
                                    />
                                    
                                </S.divPesq>
                            </div>

                            {listaPesquisa.nomeItem &&
                                <S.divListaBD onClick={()=> seteditarFornecedor(false)}>
                                    <ListaItemBD
                                    Cadastro={true}
                                    listaItem={listaPesquisa.listaFornecedor}
                                    NovoCadastro={NovoFornecedor}
                                    referenciaRef={referenciaRef}
                                    />
                                </S.divListaBD>
                            }
                        </div>
                        :
                        evento.id_Fornecedor &&
                        <S.box1>
                            <div className='listaFlexCol'>
                                <span> Fornecedor: </span>
                                <span
                                className='intem'
                                style={{ cursor: !disabledEven ? "pointer" : "not-allowed", backgroundColor:"#30353F", padding: "5px 0", }}
                                onClick={() => !disabledEven ? (FuncEditarFornecedor(), setReferenciaRef("RefFornecedor")) : ""}
                                >
                                    {evento.fornecedor}
                                </span>
                            </div>
                        </S.box1>
                        }

                        {/* ---------inputs Fornecedor---------- */}
                        {
                        veiculo.id_Veiculo && !evento.id_Fornecedor && novoFornecedor &&
                        <S.box1 style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "12px", width: "98%", padding: "14px", boxSizing: "border-box", background: "#1f1f1f", border: "1px solid #2d2d2d", borderRadius: "10px" }}>
                            <div className='listaFlexCol' style={{ gridColumn: "1 / -1", minWidth: 0 }}>
                                <span style={{ color: (playmodal.playModalEditar || novoFornecedor) && "yellow" }}>Novo Fornecedor:</span>
                                <input
                                style={{ width: "100%", boxSizing: "border-box" }}
                                disabled={disabledEven}
                                value={evento.fornecedor}
                                className='maiusculo'
                                type='text'
                                placeholder='nome'
                                onChange={e => SetEvento('fornecedor', e.target.value)}
                                />
                            </div>

                            {evento.cnpjForne.length <= 11 ?
                            <div className='listaFlexCol' style={{ minWidth: 0 }}>
                                <span style={{ color: (playmodal.playModalEditar || novoFornecedor) && "yellow" }}>CPF/CNPJ:</span>
                                <MaskedInput
                                style={{ width: "100%", boxSizing: "border-box" }}
                                disabled={disabledEven}
                                value={evento.cnpjForne}
                                type='text'
                                placeholder='cpf/cnpj'
                                mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                                onChange={e => SetEvento('cnpjForne', e.target.value.replace(/\D/gim, ''))}
                                guide={false}
                                />
                            </div>
                            :
                            <div className='listaFlexCol' style={{ minWidth: 0 }}>
                                <span style={{ color: (playmodal.playModalEditar || novoFornecedor) && "yellow" }}>CNPJ:</span>
                                <MaskedInput
                                style={{ width: "100%", boxSizing: "border-box" }}
                                disabled={disabledEven}
                                value={evento.cnpjForne}
                                type='text'
                                placeholder='cpf/cnpj'
                                mask={[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                                onChange={e => SetEvento('cnpjForne', e.target.value.replace(/\D/gim, ''))}
                                guide={false}
                                />
                            </div>
                            }

                            <div className='listaFlexCol' style={{ minWidth: 0 }}>
                                <span style={{ color: (playmodal.playModalEditar || novoFornecedor) && "yellow" }}>
                                    Chave Pix:
                                </span>
                                <input
                                style={{ textTransform: "lowercase", width: "100%", boxSizing: "border-box" }}
                                disabled={disabledEven}
                                type="text"
                                placeholder='chave pix'
                                value={evento.chavePix}
                                onChange={(e) => SetEvento("chavePix", e.target.value)}
                                />
                            </div>

                            {!evento.id_Fornecedor &&
                            <button
                            style={{ gridColumn: "1 / -1", padding: "10px", fontWeight: "bold", cursor: disabledEven ? "not-allowed" : "pointer", backgroundColor: "#00D594", color: "#000", border: "none", borderRadius: "6px" }}
                            disabled={disabledEven}
                            type='button'
                            onClick={() => AddFornecedor()}>Adicionar Fornecedor
                            </button>
                            }
                        </S.box1>
                        }
                    </S.div3>
                }

                <S.div3>
                    { //--------inputs Evento----------
                    (evento.id_Fornecedor || IndenizaçãoTotal || isFinanciamento || playmodal.playModalEditar) && 
                    <>
                        <S.box1 style={{padding: " 0 3px",}}>
                            <div className='listaFlexCol'>
                                <span>{evento.id_EventoRef? "Data Vencimento:" : "Data Evento:"} </span>
                                <input
                                    disabled={disabledEven || exigePlacaTerceiro || editandoVistoriaEvento}
                                    type="date"
                                    placeholder='Data Evento'
                                    value={evento.dataEvento || ""}
                                    onChange={e => {
                                        const novaData = e.target.value;
                                        if (!ValidarDataEventoMinima(novaData)) return;
                                        SetEvento('dataEvento', novaData);
                                    }}
                                    min={dataMinimaEvento || undefined}
                                    max={dataFormatada}
                                />
                            </div>
                            {playmodal.playModalEditar && !editandoVistoriaEvento &&
                                <div className='listaFlexCol' style={{ width: "98%" }}>
                                    <span>Tipo Evento:</span>
                                    <div className='intem'>{getTipoEventoLabel(evento.tipoEvento)}</div>
                                </div>
                            }
                            
                            {!isFinanciamento &&
                            <>
                            {!fornecedorPreEvento &&
                            <>
                            <div className='listaFlexCol' style={{ minWidth: "80px"}}>
                                <span>Total Serviços R$:</span>
                                <input
                                    disabled={disabledEven}
                                    type="number"
                                    value={evento.orcamento}
                                    onChange={(e) => SetEvento("orcamento", e.target.value)}
                                />
                            </div>

                            <div className='listaFlexCol'>
                                <span>Nota/NF/BO:</span>
                                <input
                                disabled={disabledEven}
                                type="text"
                                className='uppercase'
                                placeholder='n°'
                                value={evento.ocorrenciaBO}
                                onChange={e => SetEvento('ocorrenciaBO', e.target.value)}
                                />
                            </div>
                            </>
                            }
                            {/* Adicionar arquivos */}
                            <div style={{flex: 0, justifyContent: 'center'}}>
                                <img
                                src={icon_file}
                                onClick={() => !disabledEven && SelectFile()}
                                style={{ display:"flex", width: "25px", cursor: !disabledEven ? "pointer" : "not-allowed"}}
                                />
                            </div>
                            </>
                            }
                        </S.box1>

                        { /* ----------Financiamento------------------- */
                        isFinanciamento &&
                        <S.box1 style={{ padding: "8px 3px" }}>
                            <div className='listaFlexCol' style={{ minWidth: "100px" }}>
                                <span>N° Parcelas:</span>
                                <input
                                    disabled={disabledEven}
                                    type="number"
                                    min="1"
                                    value={evento.numeroParcelas}
                                    onChange={(e) => SetFinanciamento("numeroParcelas", e.target.value)}
                                />
                            </div>
                            <div className='listaFlexCol' style={{ minWidth: "120px" }}>
                                <span>Valor Parcela R$:</span>
                                <input
                                    disabled={disabledEven}
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={evento.valorParcela}
                                    onChange={(e) => SetFinanciamento("valorParcela", e.target.value)}
                                />
                            </div>
                            <div className='listaFlexCol' style={{ minWidth: "100px" }}>
                                <span>Dia Vencimento:</span>
                                <input
                                    disabled={disabledEven}
                                    type="number"
                                    min="1"
                                    max="31"
                                    value={evento.diaVencimento}
                                    onChange={(e) => SetEvento("diaVencimento", e.target.value)}
                                />
                            </div>
                        </S.box1>
                        }

                        {isFinanciamento &&
                        <S.box1 style={{ padding: "8px 3px", alignItems: "center", justifyContent: "space-between" }}>
                            <div className='listaFlexCol' style={{ minWidth: "130px" }}>
                                <span>Primeira Parcela:</span>
                                <input
                                    disabled={disabledEven}
                                    type="date"
                                    value={evento.primeiraParcela}
                                    onChange={(e) => SetEvento("primeiraParcela", e.target.value)}
                                />
                            </div>
                            <div className='listaFlexCol'>
                                <span>Total Financiamento:</span>
                                <strong style={{ color: "#00D594", fontSize: "1.1rem" }}>
                                    {Number(evento.orcamento || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                </strong>
                            </div>
                            <div style={{ flex: 0, justifyContent: 'center' }}>
                                <img
                                src={icon_file}
                                onClick={() => !disabledEven && SelectFile()}
                                style={{ display:"flex", width: "25px", cursor: !disabledEven ? "pointer" : "not-allowed"}}
                                />
                            </div>
                        </S.box1>
                        }

                        
                        {/guincho/i.test(evento.tipoEvento) ?
                        <S.box1>
                            <div className='listaFlexCol' style={{ minWidth: "120px" }}>
                                <span>Origem:</span>
                                <input
                                    disabled={disabledEven}
                                    value={guincho.origem}
                                    className='maiusculo'
                                    type='text'
                                    placeholder='cidade/bairro'
                                    onChange={e => SetGuincho('origem', e.target.value)}
                                />
                            </div>
                            <div className='listaFlexCol' style={{ minWidth: "120px" }}>
                                <span>Destino:</span>
                                <input
                                    disabled={disabledEven}
                                    value={guincho.destino}
                                    className='maiusculo'
                                    type='text'
                                    placeholder='cidade/bairro'
                                    onChange={e => SetGuincho('destino', e.target.value)}
                                />
                            </div>
                            <div className='listaFlexCol' style={{ minWidth: "80px" }}>
                                <span>Total KM:</span>
                                <input
                                    disabled={disabledEven}
                                    value={guincho.km}
                                    type='number'
                                    placeholder='KM'
                                    onChange={e => SetGuincho('km', e.target.value)}
                                />
                            </div>
                        </S.box1>

                        :
                        
                        evento.tipoEvento === 'C.Reserva' &&
                        <S.box1>
                            <div className='listaFlexCol' style={{ minWidth: "150px" }}>
                                <span>Inicio:</span>
                                <input
                                    disabled={disabledEven}
                                    value={evento.inicioCReserva ? playmodal.playModalEditar ? format(new Date(evento.inicioCReserva + 'T00:00:00'), 'yyyy-MM-dd') : evento.inicioCReserva : ""}
                                    type='date'
                                    onChange={e => SetEvento('inicioCReserva', e.target.value)}
                                />
                            </div>
                            <div className='listaFlexCol' style={{ minWidth: "150px" }}>
                                <span>Fim:</span>
                                <input
                                    disabled={disabledEven}
                                    value={evento.fimCReserva ? playmodal.playModalEditar ? format(new Date(evento.fimCReserva + 'T00:00:00'), 'yyyy-MM-dd') : evento.fimCReserva : ""}
                                    type='date'
                                    onChange={e => SetEvento('fimCReserva', e.target.value)}
                                />
                            </div>
                        </S.box1>
                        }  

                        <S.boxFiles>
                            <AddArquivos />
                        </S.boxFiles>
                        
                        {eventoComplemento ?
                        <>
                            <span style={{ color: corTitulo }}>Descrição anterior:</span>
                            <textarea
                            disabled
                            rows={4}
                            value={descricaoParaTexto(eventoComplemento.descricao)}
                            />
                            
                            <textarea
                            disabled={disabledEven}
                            rows={4}
                            placeholder='Nova descrição:'
                            value={novaDescricao}
                            onChange={e => {
                                setNovaDescricao(e.target.value);
                                const anterior = descricaoParaTexto(eventoComplemento.descricao);
                                SetEvento('descricao', e.target.value ? (anterior ? `${anterior}\n\n${e.target.value}` : e.target.value) : anterior);
                            }}
                            />
                        </>
                        :
                        <textarea
                        disabled={disabledEven}
                        rows={5}
                        placeholder='Detalhes da Ocorrencia:'
                        value={evento.descricao}
                        onChange={e => SetEvento('descricao', e.target.value)}
                        />
                        }
                        
                        {/* ----------------- */}

                        <S.divButton editModal={editModal}>
                            {editModal ?
                            <button
                            style={editandoCampos ? undefined : {backgroundColor:"#f7c306", color:"black"}}
                            type='button'
                            onClick={Atualizar}
                            >
                                {editandoCampos ? "Salvar" : "Atualizar"}
                            </button>
                            :
                            <button
                            style={{ cursor: !veiculo.placa || !evento.tipoEvento || !evento.dataEvento ? "not-allowed" : "pointer", ...(eventoComplemento && { backgroundColor: "#f7c306", color: "black" }) }}
                            type='button'
                            onClick={() => {
                                if (!ValidarDataEventoMinima(evento.dataEvento)) return;

                                if (evento.tipoEvento === 'Financiamento') {
                                    const pendentes = [];
                                    if (!evento.dataEvento) pendentes.push('Data Evento');
                                    if (!(Number(evento.numeroParcelas) > 0)) pendentes.push('N° Parcelas');
                                    if (!(Number(String(evento.valorParcela).replace(",", ".")) > 0)) pendentes.push('Valor Parcela');
                                    if (!(Number(evento.diaVencimento) >= 1 && Number(evento.diaVencimento) <= 31)) pendentes.push('Dia Vencimento (1 a 31)');
                                    if (!evento.primeiraParcela) pendentes.push('Primeira Parcela');

                                    if (pendentes.length > 0) {
                                        alert(`Preencha os campos do financiamento: ${pendentes.join(', ')}.`);
                                        return;
                                    }
                                }

                                if (exigePlacaTerceiro && !terceiro.placa) {
                                    alert("Pesquise e selecione a placa do terceiro.");
                                    return;
                                }

                                if (eventoComplemento) {
                                    if (!evento.id_Fornecedor || fornecedorPreEvento) {
                                        alert("Selecione um fornecedor diferente de Pre-Evento.");
                                        return;
                                    }
                                    if (!(Number(evento.orcamento) > 0)) {
                                        alert("Informe o Total Serviços com valor maior que zero.");
                                        return;
                                    }
                                    return AtualizarIdEvento({});
                                }

                                if (parametroInit.atualizarModal) {
                                    if (!ValidarEdicaoVistoriaEvento()) return;
                                    return AtualizarIdEvento({});
                                }

                                if (!fornecedorPreEvento && !(Number(evento.orcamento) > 0)) {
                                    alert("Informe o Total Serviços com valor maior que zero.");
                                    return;
                                }

                                if (!Array.isArray(listaPesquisa.listaArquivos) || listaPesquisa.listaArquivos.length === 0) {
                                    alert("Selecione ao menos um arquivo.");
                                    return;
                                }
                                
                                AddEvento();
                            }}
                            >
                                {eventoComplemento ? "Atualizar" : "Salvar"}
                            </button>
                            }
                        </S.divButton>

                    </>}
                </S.div3>
            </S.Container>
        </S.body>
    );
}

export default ModalEvento;
